/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Suggestion_Reject_AllInputs */



/**
* | output |
* | --- |
* | "Reject All" |
*
* @param {Editor_Suggestion_Reject_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_suggestion_reject_all = /** @type {((inputs?: Editor_Suggestion_Reject_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Suggestion_Reject_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle ablehnen")
	return /** @type {LocalizedString} */ ("Reject All")
});